// ─── MODAL: EDITAR CONTATO (atualiza base original) ───────────
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { API_URL } from '../../config';
import { getToken } from '../../utils/auth';
import { inp, modalOverlayLocal, modalContentLocal, btnSecLocal, btnPriLocal } from './utils';

export function ModalEditarContato({ contatoId, clienteId, onClose, onSaved }: {
  contatoId: number;
  clienteId: number;
  onClose: () => void;
  onSaved: () => void;
}) {
  const [form, setForm] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [salvando, setSalvando] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const token = await getToken();
        const res = await axios.get(`${API_URL}/comercial/clientes/${clienteId}/contatos`,
          { headers: { Authorization: token } });
        const data = res.data.body ? JSON.parse(res.data.body) : res.data;
        const c = (Array.isArray(data) ? data : []).find((x: any) => x.id === contatoId);
        if (c) setForm({ ...c });
      } finally { setLoading(false); }
    })();
  }, [contatoId, clienteId]);

  async function salvar() {
    if (!form?.nome?.trim()) { alert('Nome obrigatório'); return; }
    setSalvando(true);
    try {
      const token = await getToken();
      await axios.put(`${API_URL}/comercial/contatos/${contatoId}`, form,
        { headers: { Authorization: token } });
      onSaved();
    } catch (e: any) {
      alert('Erro: ' + (e.response?.data?.error || e.response?.data?.erro || e.message));
    } finally { setSalvando(false); }
  }

  if (loading || !form) return null;
  const lbl: React.CSSProperties = { fontSize: 11, fontWeight: 600, color: '#555', display: 'block', marginBottom: 3 };
  return (
    <div style={modalOverlayLocal} onClick={onClose}>
      <div style={{ ...modalContentLocal, maxWidth: 480 }} onClick={e => e.stopPropagation()}>
        <h3 style={{ margin: '0 0 14px', fontSize: 15, color: '#020D7F' }}>Editar contato</h3>
        <div style={{ display: 'grid', gap: 10 }}>
          <div>
            <label style={lbl}>Nome *</label>
            <input value={form.nome || ''}
              onChange={e => setForm({ ...form, nome: e.target.value })} style={inp} />
          </div>
          <div>
            <label style={lbl}>Cargo</label>
            <input value={form.cargo || ''}
              onChange={e => setForm({ ...form, cargo: e.target.value })} style={inp} />
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
            <div>
              <label style={lbl}>E-mail</label>
              <input type="email" value={form.email || ''}
                onChange={e => setForm({ ...form, email: e.target.value })} style={inp} />
            </div>
            <div>
              <label style={lbl}>Telefone / Celular</label>
              <input value={form.telefone || ''}
                onChange={e => setForm({ ...form, telefone: e.target.value })}
                placeholder="(51) 99999-9999" style={inp} />
            </div>
          </div>
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, cursor: 'pointer' }}>
            <input type="checkbox" checked={!!form.decisor}
              onChange={e => setForm({ ...form, decisor: e.target.checked })} />
            ★ Decisor
          </label>
        </div>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 14 }}>
          <button onClick={onClose} style={btnSecLocal}>Cancelar</button>
          <button onClick={salvar} disabled={salvando} style={btnPriLocal}>
            {salvando ? 'Salvando...' : 'Salvar contato'}
          </button>
        </div>
      </div>
    </div>
  );
}
